module.exports = __webpack_public_path__ + "img/20190718163053158.4e620f60.png";